export default "__VITE_ASSET__BNLntYSI__"